<page-grid
  [gridConfig]="commissionReconciliationGrid()"
  (gridEvent)="uploadFileDialog()"
  (gridSecondEvent)="applyUpdate()">
    <ng-template #actionItem let-item="item">
      <div class="flexible-content">
        @if (item.fmsAdxBookingId && item.commissionStatus != "CommissionAdjusted") { 
            <mat-checkbox [(ngModel)]="item.isChecked" />
        }
        @else if (!item.fmsAdxBookingId && item.commissionStatus != "CommissionAdjusted"){
          <button mat-icon-button aria-label="Edit Commission Reconciliation" (click)="openEditCommissionReconciliationModal(item)">
            <mat-icon class="hover-icon" fontIcon="edit" />
          </button>
        }
      </div>
    </ng-template>
</page-grid>
